import { ImportantDates } from "commonAssets/components/ImportantDates";
import { Page } from "commonAssets/pages/Page";
import { appLocale, outputDiv, i18n, userLanguage, siteInfo } from "../../../common/assets/js/constants";
import { createElement, loadingGif, toggleFieldError, validateField, modal, clearMessage } from "../../../common/assets/js/helpers";
import { SubmitClaim } from "commonAssets/components/Forms/SubmitClaim";

export class customSubmitClaim extends SubmitClaim {
    constructor(data, language, customInitClaim = null, customProcessClaim = null, claimFormSlug = null) {
        super(data, language);
        this.customInitClaim = customInitClaim;
        this.customProcessClaim = customProcessClaim;
        this.claimFormSlug = claimFormSlug;
    }

    init_claim(form) {
        this.claim.api.claimsDeadlineGet({ domain: this.claim.data.domain }).then((result) => {

            // Claim Deadline - Default Pacific DateTime
            let datetime;
            if (Boolean(result.data.pacific_datetime)) {
                datetime = result.data.pacific_datetime;
            }
            else {
                datetime = `<pre>Error: datetime</pre>`;
            }

            let claim_deadline;
            if (Boolean(result.data.claim_deadline)) {
                claim_deadline = result.data.claim_deadline;
            }

            // Error Handling
            if (result.data.error) {
                this.setup_result_data_error(result);
                return;
            }

            const container = createElement("div", {
                class: "display-form",
            });

            /** 
             * Claim Guard
             */
            if (form.form_options.notice_confirmation.display === true) {

                // Guard
                container.appendChild(this.guard(form, datetime));
                outputDiv.appendChild(container);


                const zero_zero_id = document.getElementById('zero_zero_id');
                const confirmation_code = document.getElementById('confirmation_code');
                const skip_guard = document.getElementById("skip-guard");

                // Notice Id and Confirmation Code
                [zero_zero_id, confirmation_code].forEach(function (input) {
                    input.addEventListener('change', validateField);
                });

                // Skip Guard
                if (skip_guard) {
                    skip_guard.addEventListener("click", () => {
                        // Hide guard
                        // document.getElementById('guard').classList.add("d-none");
                        document.getElementById('guard').remove();
                        // New Claim Form
                        container.appendChild(this.claim_form(form, datetime));
                        container.scrollIntoView({ behavior: "smooth" });
                        outputDiv.appendChild(container);

                        // Init claim fields
                        this.init_claim_fields(this.claim, form, claim_deadline);
                    });
                }

                // ada compliance updates - added
                // if input#submit-guard was clicked add .was-verified to form#guard 
                document.getElementById("submit-guard").addEventListener('click', () => {
                    document.getElementById("guard").classList.add("was-validated");
                    // TODO: add required text to labels
                });

                // Validate Guard Fields
                document.getElementById("guard").addEventListener("submit", (e) => {

                    e.preventDefault();

                    var valid = true;
                    var member = {
                        domain: this.claim.data.domain,
                        zero_zero_id: zero_zero_id.value.toUpperCase(),
                        confirmation_code: confirmation_code.value,
                    };

                    clearMessage();

                    // Validate guard fields
                    [zero_zero_id, confirmation_code].forEach(function (input) {
                        valid = validateField(input) && valid;
                    });
                    if (!valid) return;

                    loadingGif(loading, "show");

                    // Retrieve class member data (use POST to pass notice id and confirmation code privately)
                    this.claim.api.classMemberPost({}, member).then((result) => {

                        // Check for error message
                        if (result.data.error) {
                            toggleFieldError(zero_zero_id, true, '');
                            toggleFieldError(confirmation_code, true, '');
                            this.errorHandler.log_exception(new Error('Error loading class member', { cause: result }));
                            this.errorHandler.display_modal(result);
                            return;
                        }

                        // Add notice id and confirmation code to claim data
                        this.claim.data.zero_zero_id = member.zero_zero_id;
                        this.claim.data.confirmation_code = member.confirmation_code;

                        // Define the environment for the OTP
                        let environment = this.claim.data.domain.split('.')[0]; // ada compliance - added

                        /** @description deficiency portal update */
                        let cmData = result.data.cm_data || result.data.class_member.cm_data;
                        let canEditClaim = cmData.can_edit;
                        let isDeficient = cmData.is_deficient;
                        if (!canEditClaim || !isDeficient) {
                            loadingGif(loading, "hide", 250);
                            modal(i18n.getTranslation('error'), `This portal is closed for edits.`);
                            return;
                        }
                        // END deficiency portal update

                        if (result.data.claim_id) {
                            this.claim.data.claim_id = result.data.claim_id;
                            this.claim.class_member = result.data;
                            if (environment !== 'local') {
                                this.send_otp(form, container, result.data, claim_deadline);
                                return;
                            };
                        }

                        // Populate claim form
                        this.populate_claim_form(form, container, result.data, claim_deadline);

                    }).catch((error) => {
                        this.errorHandler.log_exception(new Error('Error loading class member', { cause: error }));
                        this.errorHandler.display_modal(error);
                    });
                });
            }
            /**
             * No Claim Guard
             */
            else {
                // Edit claim link
                this.edit_claim(form);

                // New Claim Form
                let deadlineSpan = uniformClaimDeadline(claim_deadline);
                container.appendChild(this.claim_form(form, deadlineSpan));
                outputDiv.appendChild(container);

                // Init claim fields
                this.init_claim_fields(this.claim, form, claim_deadline);
            }

            loadingGif(loading, "hide", 250)

        }).catch((error) => {
            this.errorHandler.log_exception(new Error('Error fetching claim deadline', { cause: error }));
            this.errorHandler.display(error);
        });
    }

    edit_claim(form) {
        /**
         * This blank method removes the claim form edit link on top of the 
         * claim form. Removed per PM. Add a blank div to the top for some 
         * breathing room.
         */
        const div = createElement("div", {
            class: "pb-1"
        }, [], `&nbsp;`);
        outputDiv.appendChild(div);

        // Return form
        return form;
    }

    claim_form(params) {

        // Consummer
        if (document.querySelector('label[for="checkbox_confirm_1_0"]')) {
            setTimeout(() => {
                document.querySelector('label[for="checkbox_confirm_1_0"]').classList.add("fw-bold")
            }, 1000);
        }

        // Assume this is a consumer claim filing
        let _3dp_toggle = false;

        // Let's add additional fields to the defaultForm.
        if (this.claimFormSlug === 'claim-form-3rd-party') {
            this._3dp_defaultForm(params);
            _3dp_toggle = true;
        }

        // The form
        const form = createElement("form", {
            class: "needs-validation",
            id: "form",
            method: "post"
        }, [
            createElement("h3", {
                class: "text-center mb-3",
                id: "claimFormDeadline"
            }, [], params.form_options.claim_deadline_alert.claim_form),
            createElement("div", {
                class: "alert alert-info text-center fw-bold text-dark",
                id: "confirmation-email-alert",
                role: "alert"
            }, [], params.form_options.claim_form.confirmation_email_notice),
            this.claim_instructions(params),
            _3dp_toggle ? createElement("div", [], [], params.form_options.claim_form.general_instructions.altBody) : ``,
            this.claim_contact_information(params),
            this.claim_fieldset(params),
            _3dp_toggle ? this.claim_transactions(params) : ``,
            params.claim_upload.documentation.required ? this.claim_documentation(params) : ``,
            // this.claim_payment_method(params),
            this.claim_certification(params),
        ]);
        return form;
    }

    _3dp_defaultForm(params) {
        // New instructions.
        let _3dp_contact = [
            {
                "type": "text",
                "required": true,
                "label": "Company Name or Health Plan Name",
                "className": "form-control",
                "name": "business_name",
                "access": false,
                "subtype": "text"
            }
        ];
        let _3dp_claim_form_contact_info_title = `Contact Information`;
        let _3dp_general_instructions = `
        <h3 class="text-center">INSTRUCTIONS FOR SUBMITTING YOUR THIRD-PARTY PAYOR CLAIM FORM</h3>
        <p>A Third-Party Payor (“TPP”) Class Member or an authorized agent can complete this Claim Form. If both a Class Member
            and its authorized agent submit a Claim Form, the Claims and Notice Administrator will only consider the Class
            Member’s Claim Form. The Claims and Notice Administrator may request supporting documentation in addition to the
            documentation and information requested below. The Claims and Notice Administrator may reject a claim if the TPP
            Class Member or their authorized agent does not provide all requested documentation in a timely manner.</p>
        <p>If you are a Class Member submitting a Claim Form on your own behalf, you must provide the information requested in
            “Section A - COMPANY OR HEALTH PLAN CLASS MEMBER ONLY,” in addition to the other information requested by this Claim
            Form.</p>
        <p>If you are an authorized agent of one or more Class Members, you must provide the information requested in “Section B
            - AUTHORIZED AGENT ONLY,” in addition to the other information requested by this Claim Form. Do not submit a Claim
            Form on behalf of any Class Member unless that Class Member provided prior authorization to submit the Claim Form.
        </p>
        <p>If you are submitting a Claim Form only as an authorized agent of one or more Class Members, you may submit a
            separate Claim Form for each Class Member, OR you may submit one Claim Form for all such Class Members as long as
            you provide the information required for each Class Member on whose behalf you are submitting the form.</p>
        <p>If you are submitting Claim Forms both on your own behalf as a Class Member AND as an authorized agent on behalf of
            one or more Class Members, you should submit one Claim Form for yourself, completing Section A, and another Claim
            Form or Forms as an authorized agent for the other Class Member(s), completing Section B. </p>
        <p>To qualify to receive a payment from the Settlement, you must complete and submit this Claim Form either on paper or
            electronically on this website and you may need to provide certain requested documentation to substantiate your
            Claim.</p>
        <p>Your failure to complete and submit the Claim Form postmarked or filed online by August 18, 2023, will prevent you
            from receiving any payment from the Settlement. Submission of this Claim Form does not ensure that you will share in
            the payments related to the Settlement. If the Claims and Notice Administrator rejects or reduces your Claim, you
            may invoke the dispute resolution process described on pages 5-6.</p>
        <h4 class="text-center my-3">CLAIM INFORMATION AND DOCUMENTATION REQUIREMENTS</h4>
        <p>Please provide the following information to support your Claim for purchases and/or reimbursement of brand or generic
            Exforge (fixed combination of amlodipine and valsartan tablets) for use by your members, employees, insureds,
            participants, or beneficiaries, where such persons purchased the drug in a pharmacy or received brand or generic
            Exforge by mail-order prescription, from September 21, 2012 through June 30, 2018, in the following states: </p>
        <p>District of Columbia, Arizona, California, Florida, Hawaii, Iowa, Maine, Michigan, Minnesota, Nebraska, Nevada, New
            Hampshire, New Mexico, New York, North Carolina, North Dakota, Oregon, South Dakota, Utah, Vermont, West Virginia,
            or Wisconsin.</p>
        <ul>
            <li>Unique patient identification number or code:
                <ol type="a">
                    <li>Unique patient identification number or code.</li>
                    <li>NDC Number (a list of NDC Numbers is available at the Important Documents page of this website) - e.g.,
                        00000-0000-00</li>
                    <li>Fill Date or Date of Service - e.g., 01/01/2011</li>
                    <li>Location (State) of Service - e.g., CA</li>
                    <li>Amount Billed (not including dispensing fee) - e.g., $40.00</li>
                    <li>Amount Paid by TPP net of co-pays, deductibles, and co-insurance - e.g., $20.00</li>
                </ol>
            </li>
            <li>If you are submitting a Claim Form on behalf of multiple Class Members, also provide the following information
                for each prescription:
                <ol type="a">
                    <li>Plan or Group Name. </li>
                    <li>Plan or Group FEIN - provide group number for each transaction.</li>
                </ol>
            </li>
        </ul>
        <p>Information submitted will be covered by the Protective Order entered by the Court. For your convenience, an exemplar
            spreadsheet containing these categories is available on the Important Documents page of this website.</p>
        <p>Please use this format if possible. Following the exemplar spreadsheet, the website provides a list of the NDCs that
            the Claims and Notice Administrator will consider. If possible, please provide the electronic data in Microsoft
            Excel, ASCII flat file pipe “|”, tab-delimited, or fixed-width format.</p>
        <p>Following the exemplar spreadsheet, the website provides a reference list of the NDCs for Exforge and generic
            Exforge, although other NDCs may have been in use during the class period and are not on this list. If possible,
            please provide the electronic data in Microsoft Excel, ASCII flat file pipe “|”, tab-delimited, or fixed-width
            format.</p>
        <p><strong>To facilitate and expedite the review and processing of any claim form, each claimant is strongly encouraged
            to provide claims data reflecting that claimant’s purchases and/or payments of Exforge and generic Exforge,
            using the Excel template found on this website.</strong> Transaction data supporting claims is mandatory for
            claims of $100,000 or more, although the Claims and Notice Administrator may also require transaction data for
            claims of less than $100,000. Please keep related transaction data and any other documentation supporting your Claim
            (e.g., invoices) in case the Claims and Notice Administrator requests it later. If your Claim is for less than
            $100,000, you should still provide the transaction data with your Claim submission if you can. If, after an audit of
            your Claim, the Claims and Notice Administrator still has questions about your Claim and you have not provided
            sufficient substantiation of your Claim, the Claims and Notice Administrator may reject your Claim.</p>
        <p>Please contact the Claims and Notice Administrator at 1-833-741-2334 with any questions about the required claims
            information or documentation.</p>
        `;
        let _3dp_section_a = `
        <p class="fw-bold d-none">ATTENTION: THIS FORM IS ONLY TO BE FILLED OUT ON BEHALF OF A THIRD-PARTY PAYOR (OR AN AUTHORIZED AGENT) AND NOT INDIVIDUAL CONSUMERS.</p>
        <ul class="mb-5 d-none">
            <li>Complete Section A only if you are filing as an individual TPP Class Member.</li>
            <li>Complete Section B only if you are an authorized agent filing on behalf of one or more TPP Class Members.</li>
        </ul>
        `;
        let _3dp_claim_fields_title = `Third-Party Payor Claim`;
        let _3dp_claim_fieldset = [
            {
                "type": "header",
                "subtype": "h4",
                "label": "Section A: Company or Health Plan Class Member Only",
                "className": "fw-normal",
                "parentClass": "d-none",
                "access": false
            },
            {
                "type": "paragraph",
                "subtype": "p",
                "label": "<i class=\"bi bi-exclamation-triangle-fill text-warning\"></i> Complete Section A only if you are filing as an individual TPP Class Member. <i class=\"bi bi-exclamation-triangle-fill text-warning\"></i>",
                "className": "alert alert-info text-center text-dark fw-bold",
                "parentClass": "d-none",
                "access": false
            },
            {
                "type": "text",
                "required": false,
                "label": "Company or Health Plan Name",
                "className": "form-control",
                "parentClass": "d-none",
                "name": "text-1686506318411-0",
                "access": false,
                "subtype": "text"
            },
            {
                "type": "text",
                "required": false,
                "label": "Tax Identification Number",
                "className": "form-control",
                "parentClass": "d-none",
                "name": "text-1686506318312-0",
                "access": false,
                "subtype": "text"
            },
            {
                "type": "paragraph",
                "subtype": "p",
                "label": "<i class=\"bi bi-exclamation-triangle-fill text-warning\"></i> You will be asked to list other names by which your company or health plan has been known or other Federal Employer Identification Numbers (\"FEINs\") it has used since September 21, 2012 below on <em>Third-Party Payor Claim (Continued)<\/em>. <i class=\"bi bi-exclamation-triangle-fill text-warning\"></i>",
                "className": "fw-bold text-center",
                "parentClass": "d-none",
                "access": false
            },
            {
                "type": "checkbox-group",
                "required": false,
                "label": "Health Insurance Company/HMO",
                "toggle": false,
                "inline": false,
                "name": "checkbox-group-health-insurance-company-hmo",
                "access": false,
                "other": false,
                "parentClass": "d-none",
                "values": [
                    {
                        "label": "Health Insurance Company/HMO",
                        "value": "YES",
                        "selected": true
                    }
                ]
            },
            {
                "type": "checkbox-group",
                "required": false,
                "label": "Self-Insured Employee Health or Pharmacy Benefit Plan",
                "toggle": false,
                "inline": false,
                "name": "checkbox-group-self-insured-employee-health-or-pharmacy-benefit-plan",
                "access": false,
                "other": false,
                "parentClass": "d-none",
                "values": [
                    {
                        "label": "Self-Insured Employee Health or Pharmacy Benefit Plan",
                        "value": "YES",
                        "selected": false
                    }
                ]
            },
            {
                "type": "checkbox-group",
                "required": false,
                "label": "Self-Insured Health & Welfare Fund",
                "toggle": false,
                "inline": false,
                "name": "checkbox-group-self-insured-health-and-welfare-fund",
                "access": false,
                "other": false,
                "parentClass": "d-none",
                "values": [
                    {
                        "label": "Self-Insured Health & Welfare Fund",
                        "value": "YES",
                        "selected": false
                    }
                ]
            },
            {
                "type": "checkbox-group",
                "required": false,
                "label": "Other (Explain)",
                "toggle": false,
                "inline": false,
                "name": "checkbox-group-other-explain",
                "access": false,
                "other": false,
                "parentClass": "d-none",
                "values": [
                    {
                        "label": "Other (Explain)",
                        "value": "YES",
                        "selected": false
                    }
                ]
            },
            {
                "type": "text",
                "required": false,
                "label": "Other Explained:",
                "className": "form-control mb-5",
                "parentClass": "d-none",
                "name": "text-1686506318105-0",
                "access": false,
                "subtype": "text"
            },
            {
                "type": "header",
                "subtype": "h4",
                "label": "Section B: Authorized Agent Only",
                "className": "fw-normal",
                "parentClass": "d-none",
                "access": false
            },
            {
                "type": "paragraph",
                "subtype": "p",
                "label": "<i class=\"bi bi-exclamation-triangle-fill text-warning\"></i> Complete Section B only if you are an authorized agent filing on behalf of one or more TPP Class Members. <i class=\"bi bi-exclamation-triangle-fill text-warning\"></i>",
                "className": "alert alert-info text-center text-dark fw-bold",
                "parentClass": "d-none",
                "access": false
            },
            {
                "type": "paragraph",
                "subtype": "p",
                "label": "As an authorized agent, please check how your relationship with the Class Member(s) is best described (you may be required to provide documentation demonstrating this relationship):",
                "access": false,
                "parentClass": "d-none",
            },
            {
                "type": "checkbox-group",
                "required": false,
                "label": "Third-Party Administrator or Administrative Services Only Provider",
                "toggle": false,
                "inline": false,
                "name": "checkbox-group-third-party-administrator-or-administrative-services-only-provider",
                "access": false,
                "other": false,
                "parentClass": "d-none",
                "values": [
                    {
                        "label": "Third-Party Administrator or Administrative Services Only Provider",
                        "value": "YES",
                        "selected": true
                    }
                ]
            },
            {
                "type": "checkbox-group",
                "required": false,
                "label": "Pharmacy Benefits Manager",
                "toggle": false,
                "inline": false,
                "name": "checkbox-group-pharmacy-benefits-manager",
                "access": false,
                "other": false,
                "parentClass": "d-none",
                "values": [
                    {
                        "label": "Pharmacy Benefits Manager",
                        "value": "YES",
                        "selected": false
                    }
                ]
            },
            {
                "type": "checkbox-group",
                "required": false,
                "label": "Other (Explain)",
                "toggle": false,
                "inline": false,
                "name": "checkbox-group-1686507120093-0",
                "access": false,
                "other": false,
                "parentClass": "d-none",
                "values": [
                    {
                        "label": "Other (Explain):",
                        "value": "YES",
                        "selected": false
                    }
                ]
            },
            {
                "type": "text",
                "required": false,
                "label": "Other Explained:",
                "className": "form-control",
                "parentClass": "d-none",
                "name": "text-1686507371957-0",
                "access": false,
                "subtype": "text"
            },
            {
                "type": "text",
                "required": false,
                "label": "Authorized Agent's Company Name",
                "className": "form-control",
                "parentClass": "d-none",
                "name": "text-1686508578596-0",
                "access": false,
                "subtype": "text"
            },
            {
                "type": "text",
                "required": false,
                "label": "Authorized Agent's Tax Identification Number",
                "className": "form-control",
                "parentClass": "d-none",
                "name": "text-1686508626215-0",
                "access": false,
                "subtype": "text"
            },
            {
                "type": "paragraph",
                "subtype": "p",
                "label": "<i class=\"bi bi-exclamation-triangle-fill text-warning\"></i> If you completed Section B, you <em>must</em> list the name and FEIN of every Class Member (i.e., Company or Health Plan) for whom you have been duly authorized to submit this Claim Form below on <em>Third-Party Payor Claim (Continued)<\/em>. <i class=\"bi bi-exclamation-triangle-fill text-warning\"></i>",
                "className": "fw-bold text-center mb-5",
                "parentClass": "d-none",
                "access": false
            },
            {
                "type": "header",
                "subtype": "h4",
                "label": "Purchase Information",
                "className": "fw-normal",
                "access": false
            },
            {
                "type": "paragraph",
                "subtype": "p",
                "label": "Please verify in the box below below the total amount paid or reimbursed for brand or generic Exforge (fixed combination of amlodipine and valsartan tablets), net of co-pays, deductibles, and co-insurance for use by your members, employees, insureds, participants, or beneficiaries, where such persons purchased the drug in a pharmacy or received brand or generic Exforge by mail-order prescription from September 21, 2012 through June 30, 2018 in one or more of the following states:",
                "access": false
            },
            {
                "type": "paragraph",
                "subtype": "p",
                "label": "District of Columbia, Arizona, California, Florida, Hawaii, Iowa, Maine, Michigan, Minnesota, Nebraska, Nevada, New Hampshire, New Mexico, New York, North Carolina, North Dakota, Oregon, South Dakota, Utah, Vermont, West Virginia, or Wisconsin. ",
                "className": "m-3",
                "access": false
            },
            {
                "type": "text",
                "required": false,
                "label": "TOTAL AMOUNT YOU PAID FOR BRAND OR GENERIC EXFORGE (FIXED COMBINATION OF AMLODIPINE AND VALSARTAN TABLETS) – NET OF CO-PAYS, DEDUCTIBLES, DISPENSING FEES, AND CO-INSURANCE",
                "className": "form-control",
                "name": "text-1686258809513-0",
                "access": false,
                "subtype": "text"
            },
            {
                "type": "paragraph",
                "subtype": "p",
                "label": "<strong>Authorized Agents Only:</strong> For each Class Member for whom you are submitting this Claim Form, please provide the above information with respect to purchases made by the Class Member’s members, employees, insureds, participants, or beneficiaries.  If you are submitting claims for multiple Class Members, please provide, separately for each Class Member, as much of the transaction data and other information and documentation requested in the “CLAIM INFORMATION AND DOCUMENTATION REQUIREMENTS” section of the instructions above as possible. Fill out the box above with the combined amounts paid by all Class Members for whom you are submitting this Claim Form, net of co-pays, deductibles, and co-insurance.",
                "access": false
            }
        ];
        let _3dp_claim_uploads_body = `
        <p><strong>To facilitate and expedite the review and processing of any claim form, each claimant is strongly 
            encouraged to provide claims data reflecting that claimant’s purchases and/or payments of Exforge and 
            generic Exforge, using the Excel template found on this website.</strong> Transaction data supporting 
            claims is mandatory for claims of $100,000 or more, although the Claims and Notice Administrator may also 
            require transaction data for claims of less than $100,000, so keep related transaction data and any other 
            documentation supporting your Claim (e.g., invoices) in case the Claims and Notice Administrator requests 
            it later.  If your Claim is for less than $100,000, you should still provide the transaction data with your 
            Claim submission if you can.  If, after an audit of your Claim, the Claims and Notice Administrator still 
            has questions about your Claim and you have not provided sufficient substantiation of your Claim, the 
            Claims and Notice Administrator may reject your Claim.</p>
        <p>If the Claims and Notice Administrator rejects or reduces your claim and you believe the rejection or 
            reduction is in error, you may contact the Claims and Notice Administrator to request further review.  
            If the dispute concerning your claim cannot be resolved by the Claims and Notice Administrator and Class 
            Counsel, you may request that the Court review your claim.</p>
        <p>To request Court review, you must send the Claims and Notice Administrator a signed written statement 
            that (a) states your reasons for contesting the rejection or payment determination regarding your claim; 
            and (b) specifically states that you “request that the Court review the determination regarding this 
            claim.” You must include all documentation supporting your argument(s). The Claims and Notice Administrator 
            and Class Counsel will present the dispute to the Court for review, which may include public filing with 
            the Court of your claim and the supporting documentation.  Please note: Court review should only be sought 
            if you disagree with the Claims and Notice Administrator’s determination regarding your claim.</p>
        <div class='alert alert-info text-center' role='alert'>
            Authorized Agents must additionally provide proof you have authority 
            to represent the class member in this matter.
        </div>
        `;
        let _3dp_certification_body = `
        <p>I have read and am familiar with the contents of the Instructions accompanying this Claim Form.  I certify 
            that the information I have set forth in the above Claim Form and in any documents attached by me are true, 
            correct, and complete to the best of my knowledge.  I certify that I, or the Class Member(s) I represent, 
            paid or reimbursed for brand or generic Exforge in the total amount set forth above for use by members, 
            employees, insureds, participants, or beneficiaries, where such persons purchased the drug in a pharmacy or 
            received brand or generic Exforge (fixed combination of amlodipine and valsartan tablets) by mail-order 
            prescription, in the Class States listed in Section C.  </p>
        <p>I further certify that I, or the Class Member(s) I represent, did not seek to be excluded (“opt out”) from 
            the Class in this Action.  Nor did I, or the represented Class Member(s), pay for or provide reimbursement 
            of brand or generic Exforge (fixed combination of amlodipine and valsartan tablets) for purposes of resale. 
            In addition, I (or the represented Class Member(s)) are not among the entities excluded from the Class, 
            include the following: </p>
        <p class="ms-3">(a)	Defendants and their counsel, officers, directors, management, employees, subsidiaries, or 
            affiliates; </p>
        <p class="ms-3">(b)	all federal and state governmental entities (with the exception of cities, towns, 
            municipalities, or counties with self-funded prescription drug plans); </p>
        <p class="ms-3">(c)	all persons or entities who purchased Exforge for purposes of resale or directly from 
            defendants or their affiliates; </p>
        <p class="ms-3">(d)	fully-insured health plans (plans that purchased insurance from another third-party payor 
            covering 100 percent of the plan’s reimbursement obligations to its members); </p>
        <p class="ms-3">(e)	consumers using a Novartis co-pay coupon or voucher while uninsured;</p>
        <p class="ms-3">(f)	consumers using a Novartis co-pay coupon or voucher provided by Novartis that reduced their 
            out-of-pocket payment to less than $15.00 while insured;</p>
        <p class="ms-3">(g)	flat co-payors (consumers covered by plans applying the same fixed dollar co-payment to 
            both branded and generic Exforge); </p>
        <p class="ms-3">(h)	consumers who purchased only generic amlodipine valsartan (and not branded Exforge) under 
            a plan that required them to make a fixed dollar copayment; </p>
        <p class="ms-3">(i)	pharmacy benefit managers; </p>
        <p class="ms-3">(j)	persons or entities purchasing only branded Exforge after September 30, 2014, and not 
            amlodipine valsartan; </p>
        <p class="ms-3">(k)	all counsel of record; and </p>
        <p class="ms-3">(l)	the court, court personnel and any member of their immediate families. </p>
        <p>I further certify I have provided all of the information requested above to the extent I have it.</p>
        <p>To the extent I have been given authority to submit this Claim Form by one or more Class Members on their 
            behalf, and accordingly am submitting this Claim Form in the capacity of an authorized agent with authority 
            to submit it, and to the extent I have been authorized to receive on behalf of the Class Member(s) any and 
            all amounts that may be allocated to them from the Settlement Fund, I certify that such authority has been 
            properly vested in me and that I will fulfill all duties I may owe the Class Member(s).  If amounts from 
            the Settlement Fund are distributed to me and a Class Member later claims that I did not have the authority 
            to claim and/or receive such amounts on its behalf, I and/or my employer will hold the Class, counsel for 
            the Class, and the Claims and Notice Administrator harmless with respect to any claims made by the Class 
            Member.</p>
        <p>I hereby submit to the jurisdiction of the United States District Court for the Southern District of New 
            York for all purposes connected with this Claim Form, including resolution of disputes relating to this 
            Claim Form.  I acknowledge that any false information or representations contained herein may subject me to 
            sanctions, including the possibility of criminal prosecution.  I agree to supplement this Claim Form by 
            furnishing documentary backup for the information provided herein, upon request of the Claims and Notice 
            Administrator.</p>
        <p>I certify that the above information supplied by the undersigned is true and correct to the best of my 
            knowledge and that this Claim Form was executed the date listed below.</p>
        `;

        // We add an additional field to the contact info. 
        let _contact_joined = [..._3dp_contact, ...params.contact_information];

        // formDefault overwrites
        params.form_options.claim_form.general_instructions.body = _3dp_general_instructions;
        params.contact_information = _contact_joined;
        params.form_options.claim_form.general_instructions.altBody = ``;
        params.form_options.claim_form.contact_information.title = _3dp_claim_form_contact_info_title;
        params.form_options.claim_form.claim_fields.title = _3dp_claim_fields_title;
        params.form_options.claim_form.claim_fields.body = _3dp_section_a;
        params.claim_fields = _3dp_claim_fieldset;
        params.claim_upload.documentation.body = _3dp_claim_uploads_body;
        params.certification.attestation.body = _3dp_certification_body;

        return params;
    }

    init_claim_inputs() {
        this.claim.inputs.contact = Array.from(document.querySelectorAll('#full_name, #first_name, #middle_initial, #last_name, #title, #business_name, #street_address_1, #street_address_2, #country, #city, #state, #zip_code, #province, #postal_code, #email_address, #confirm_email_address, #phone_number_1, #phone_number_2, #signature, #date, #ssn, #referer_url'))
        this.claim.inputs.fields = Array.from(document.querySelectorAll("#claim-fields input, #claim-fields textarea, #claim-fields select"));
        this.claim.inputs.transactions = Array.from(document.querySelectorAll("#transactions input, #transactions textarea, #transactions select"));
    }

    destroy_claim(claim) {
        loadingGif(loading, "hide", 500); // left here

        if (claim.flags.success) {

            // Conversion pixels
            $.getScript("https://www.googletagmanager.com/gtag/js?id=G-LGF2TN8VN9", () => {
                window.dataLayer = window.dataLayer || [];
                function gtag() { dataLayer.push(arguments); }
                gtag('js', new Date());

                gtag('config', 'AW-10858394745'); // sem
                gtag('event', 'conversion', { 'send_to': 'AW-10858394745/9rw7CJStoKQDEPno17ko' });
            });
            //<img height="1" width="1" style="border-style:none;" alt="" src="https://insight.adsrvr.org/track/pxl/?adv=45mfygg&ct=0:zvheslb&fmt=3"/>
            let insight = createElement("img", {
                height: 1,
                width: 1,
                style: "border-style:none;",
                alt: "",
                src: "https://insight.adsrvr.org/track/pxl/?adv=45mfygg&ct=0:zvheslb&fmt=3"
            });
            outputDiv.appendChild(insight);

            claim.data.confirmation = this.claim_data_confirmation(claim.data);
            document.querySelector('div.display-form').classList.add('d-none');

            outputDiv.appendChild(this.claim_confirmation(claim.data));
            outputDiv.scrollIntoView({ behavior: "smooth" });

            setTimeout(() => {
                modal(i18n.getTranslation('confirmation_screen_additional')['title'], i18n.getTranslation('confirmation_screen_additional')['body']);
            }, 250);

        } else {
            modal(i18n.getTranslation('error'), i18n.getTranslation('claim_submit_error'));
        }

        // Loop thru each input and disable to prevent changes and resubmissions
        for (var type in claim.inputs) {
            if (claim.inputs[type] && claim.inputs[type].length > 0) {
                claim.inputs[type].forEach(function (field) {
                    field.disabled = true;
                });
            }
        }

        [].forEach.call(document.querySelectorAll('input[type="radio"]'), function (radio) {
            radio.setAttribute('disabled', 'disabled');
        });

        document.getElementById('submit-claim').setAttribute('disabled', 'disabled');
    }
}